import { Component, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { WebhookService } from '../services/webhook.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModalComponent } from "../../../loading-modal/loading-modal.component";
import { AlertComponent } from "../../../alert/alert.component";

@Component({
  selector: 'app-webhooks',
  standalone: true,
  imports: [MatIconModule, CommonModule, ReactiveFormsModule, FormsModule, LoadingModalComponent, AlertComponent],
  templateUrl: './webhooks.component.html',
  styleUrls: ['./webhooks.component.scss'],
  providers: [WebhookService]
})
export class WebhooksComponent  implements OnInit {

  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent !: LoadingModalComponent;
    
  public uriNRCA: string = '';

  constructor(private webhookService: WebhookService) { }

  ngOnInit() {
  this.getHookNRCA();
  }

  public getHookNRCA(){
    this.webhookService.getHookNRCA().subscribe((response: any)=>{
      this.uriNRCA = response.uri
    })
  }

  public handleUpdateUriNRCA(){
    this.loadingComponent.activeLoading();
    this.webhookService.updateHookNRCA(this.uriNRCA).subscribe((response: any)=>{
      this.getHookNRCA();
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert('Hook atualizado com sucesso!');

    }, (error: any)=> {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao atualizar o hook ${error.error.status}`)
    })
  }

}
